import { registerPlugin } from '@capacitor/core';

import { CAPACITOR_EDIT_ACTION_PLUGIN_NAME } from '../pluginConstants';
import { EditingActionPlugin } from './definitions';

const EditingAction = registerPlugin<EditingActionPlugin>(CAPACITOR_EDIT_ACTION_PLUGIN_NAME);

export { EditingAction };
